import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { nairaToBytes, bytesToNaira, formatBytes, formatNaira } from '../../utils/currency';

const CurrencyConverterModal = ({ isOpen, onClose }) => {
  const [amount, setAmount] = useState('');
  const [fromCurrency, setFromCurrency] = useState('naira'); // 'naira' or 'bytes'
  const [convertedAmount, setConvertedAmount] = useState('');

  useEffect(() => {
    if (amount && !isNaN(amount)) {
      const numAmount = parseFloat(amount);
      if (fromCurrency === 'naira') {
        setConvertedAmount(formatBytes(nairaToBytes(numAmount)));
      } else {
        setConvertedAmount(formatNaira(bytesToNaira(numAmount)));
      }
    } else {
      setConvertedAmount('');
    }
  }, [amount, fromCurrency]);

  const handleSwitch = () => {
    setFromCurrency(prev => prev === 'naira' ? 'bytes' : 'naira');
    setAmount('');
    setConvertedAmount('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-xl p-6 max-w-md w-full mx-4 relative"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <h2 className="text-2xl font-bold mb-6 text-center">Currency Converter</h2>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Amount in {fromCurrency === 'naira' ? 'Naira' : 'Bytes'}
            </label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              placeholder={`Enter amount in ${fromCurrency === 'naira' ? 'Naira' : 'Bytes'}`}
            />
          </div>

          <button
            onClick={handleSwitch}
            className="w-full flex items-center justify-center py-2 text-primary-600 hover:text-primary-700"
          >
            <span className="mr-2">⇅</span>
            Switch Currencies
          </button>

          {convertedAmount && (
            <div className="bg-primary-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">Converted Amount:</p>
              <p className="text-2xl font-bold text-primary-700">{convertedAmount}</p>
              <p className="text-xs text-gray-500 mt-2">
                1 Byte = ₦10
              </p>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default CurrencyConverterModal;